module.exports = __webpack_public_path__ + "img/icon_healthStep_download_code.73e9aa25.png";